import { ErrorMessage } from '@doordash/component-fields';
import { Text } from '@doordash/design-language';
import * as React from 'react';
import { FieldError, InputContainer } from './CardFieldsStyles';
var CardInput = function (_a) {
    var labelName = _a.labelName, error = _a.error, children = _a.children;
    return (React.createElement(Text, { tag: "label", styles: Text.Styles.Medium14 },
        React.createElement(Text, { styles: Text.Styles.Label }, labelName),
        React.createElement(InputContainer, { error: error }, children),
        error && (React.createElement(FieldError, null,
            React.createElement(ErrorMessage, { error: error })))));
};
export default CardInput;
